<div class="flexbox">
    <div class="text-muted">{{themeConfig.config.YEAR}} © <strong>{{themeConfig.config.VENDOR}}</strong>. All rights reserved ({{version}})</div>
</div>
